const { serialize } = require("../../utils");
export default {
  namespaced: true,
  state: {
    path: "aljabr/parents-chats-dev",
  },
  actions: {
    get({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    getId({ dispatch, state, rootState }, options = {}) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/id/${options.chatId}?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    addMessage({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/add-message`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    save({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/save`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    uploadFile({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/upload-file`,
          method: "VID",
          data,
        },
        { root: true }
      );
    },
  },
};
